import { idem } from '../../lib/idempotency';
import type { TapOnce } from '../ui/useTapOnce';

/**
 * One write's tap: the lock first, then the key, then the write (LESSONS 2026-10-02). The
 * caller releases the lock when the write no longer needs it (its `onSettled`, as a rule); a
 * key that cannot be minted releases it at once (`useTapOnce`). True when the write went out,
 * false for a tap the lock refused.
 */
export function sendOnce<V>(
  lock: TapOnce,
  mutate: (v: V & ReturnType<typeof idem>) => void,
  v: V,
): boolean {
  return lock.run(() => mutate({ ...v, ...idem() }));
}
